var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { SVGIcon, SVGIconGroup, SVGIconPath } from '../../components/SVGIcon';
var AlignLeftIconShape = React.createElement(SVGIconGroup, null, React.createElement(SVGIconPath, {
  d: "M20.9361702,19.0604255 C21.5237072,19.0604255 22,19.5367184 22,20.1242553 C22,20.7117923 21.5237072,21.1880851 20.9361702,21.1880851 L3.06382979,21.1880851 C2.47629282,21.1880851 2,20.7117923 2,20.1242553 C2,19.5367184 2.47629282,19.0604255 3.06382979,19.0604255 L20.9361702,19.0604255 Z M17.6868085,13.373617 C18.2743455,13.373617 18.7506383,13.8499098 18.7506383,14.4374468 C18.7506383,15.0249838 18.2743455,15.5012766 17.6868085,15.5012766 L3.06382979,15.5012766 C2.47629282,15.5012766 2,15.0249838 2,14.4374468 C2,13.8499098 2.47629282,13.373617 3.06382979,13.373617 L17.6868085,13.373617 Z M15.2493617,7.68680851 C15.8368987,7.68680851 16.3131915,8.16310133 16.3131915,8.7506383 C16.3131915,9.33817527 15.8368987,9.81446809 15.2493617,9.81446809 L3.06382979,9.81446809 C2.47629282,9.81446809 2,9.33817527 2,8.7506383 C2,8.16310133 2.47629282,7.68680851 3.06382979,7.68680851 L15.2493617,7.68680851 Z M18.4995745,2 C19.0871114,2 19.5634043,2.47629282 19.5634043,3.06382979 C19.5634043,3.65136676 19.0871114,4.12765957 18.4995745,4.12765957 L3.06382979,4.12765957 C2.47629282,4.12765957 2,3.65136676 2,3.06382979 C2,2.47629282 2.47629282,2 3.06382979,2 L18.4995745,2 Z"
}));
export var AlignLeftIcon = function AlignLeftIcon(props) {
  var className = props.className,
      restProps = __rest(props, ["className"]);

  return React.createElement(SVGIcon, Object.assign({}, restProps, {
    className: "AlignLeftIcon ".concat(className || '')
  }), AlignLeftIconShape);
};